import { render } from "./KoffietafelView.vue?vue&type=template&id=a088f1b4"
import script from "./KoffietafelView.vue?vue&type=script&lang=js"
export * from "./KoffietafelView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__